import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function DetailsPopup({ details, callDetails }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('customize_bundle_for_shp2');
    const { title, text } = details;

    return (
        <div className={`details-popup ${css['details-popup']}`}>
            <div className="details-popup-content">
                <header className="details-popup-header">
                    <span className="header-details">{t('details_popup')}</span>
                    <svg
                        className="header-close"
                        onClick={() => callDetails(null)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </header>
                <body className="details-popup-body">
                    <p className="details-title">{title}</p>
                    {Array?.isArray(text) ? (
                        <ul className="text-ul">
                            {text?.map((item: any, k: number) => (
                                <li className="details-text text-li" key={k}>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="details-text">
                            {String(text)?.startsWith('bundles.')
                                ? t.rich(text, {
                                      s: (str: string) => <span className="strong">{str}</span>,
                                  })
                                : text}
                        </p>
                    )}
                </body>
            </div>
            {/* <style jsx global>
                {`
                    .page-layout {
                        height: 100vh !important;
                        overflow: hidden !important;
                    }
                `}
            </style> */}
        </div>
    );
}
